import Action from "../action/Action.ts";

const HolidayAction = {
    get(token, callback, errorHandler) {
        const path = "/holidays";
        const header = new Headers();
        const body = null;
        Action.fetchAuthorizedJson(
            path,
            token,
            "GET",
            header,
            body,
            callback,
            errorHandler
        );
    },
};

export default HolidayAction;
